export default __webpack_public_path__ + "assets/_Chapters/UeberSSVKroschke/timeline/2005.webp";